import { render, staticRenderFns } from "./DeadlineTable.vue?vue&type=template&id=efa7cd08"
import script from "./DeadlineTable.vue?vue&type=script&lang=js"
export * from "./DeadlineTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports